import {AppState} from '@/store/state';
import {UiState} from '@/store/ui/state';
import {Component, HostBinding, OnInit, OnDestroy, ChangeDetectorRef} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppService} from '@services/app.service';
import {Observable} from 'rxjs';

const BASE_CLASSES = 'main-sidebar elevation-4';

@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit, OnDestroy {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public user;
    public menu: any;
    getUserName: string;
    getWebsiteName: string;
    private storageListener: any;

    constructor(
        public appService: AppService,
        private store: Store<AppState>,
        private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.ui = this.store.select('ui');
        this.ui.subscribe((state: UiState) => {
            this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
        });
        this.user = this.appService.user;

        this.updateMenu();

        // Watch for storage changes to update menu when website is switched
        this.storageListener = () => {
            this.updateMenu();
        };
        window.addEventListener('storage', this.storageListener);
    }

    ngOnDestroy() {
        if (this.storageListener) {
            window.removeEventListener('storage', this.storageListener);
        }
    }

    updateMenu() {
        this.getUserName = localStorage.getItem('userName');
        this.getWebsiteName = localStorage.getItem('websiteName') || localStorage.getItem('selectedWebsiteName');
        console.log('Current website name:', this.getWebsiteName);
        
        if (this.getWebsiteName && this.getWebsiteName.toLowerCase().includes('cifa')) {
            this.menu = CIFAmenu;     
        } else if (this.getWebsiteName && this.getWebsiteName.toLowerCase().includes('a-a.lighting')) {
            this.menu = AALighting;        
        } else if (this.getUserName == 'aftc' || this.getUserName == 'Chamberincharge') {
            this.menu = AFTCMenu;          
        } else if (this.getUserName == 'nsbedadmin') {
            this.menu = NsCollegeMenu;         
        } else if (this.getUserName == 'admin') {
            this.menu = AALighting;        
        } else {
            this.menu = MENU;         
        }
        
        // Trigger change detection to update the view
        this.cdr.markForCheck();
    }
}

export const MENU = [
    /*{
      name: 'Home',
      iconClasses: 'fas fa-home',
      path: ['/main/home']
    },*/
    {
        name: 'Gallery',
        iconClasses: 'fas fa-images',
        path: ['/main/gallery']
    },
    {
        name: 'Blogs',
        iconClasses: 'fas fa-blog',
        path: ['/main/blogs']
    },
    {
        name: 'News Feed',
        iconClasses: 'fas fa-newspaper',
        path: ['/main/news-feed']
    },
    {
        name: 'Press Release',
        iconClasses: 'far fa-newspaper',
        path: ['/main/press-release']
    },
    {
        name: 'Clients',
        iconClasses: 'fas fa-handshake',
        path: ['/main/company-partners']
    }
    /*{
      name: 'Blank',
      iconClasses: 'fas fa-file',
      path: ['/main/blank']
    },
    {
      name: 'Main Menu',
      iconClasses: 'fas fa-folder',
      children: [
        {
          name: 'Sub Menu',
          iconClasses: 'far fa-address-book',
          path: ['/main/sub-menu-1']
        },
        {
          name: 'Blank',
          iconClasses: 'fas fa-file',
          path: ['/main/sub-menu-2']
        }
      ]
    }*/
];

export const AFTCMenu = [
    /*{
      name: 'Home',
      iconClasses: 'fas fa-home',
      path: ['/main/home']
    },*/
    {
        name: 'Gallery',
        iconClasses: 'fas fa-images',
        path: ['/main/gallery']
    },
    /* {
       name: 'Blogs',
       iconClasses: 'fas fa-blog',
       path: ['/main/blogs']
     },*/
    {
        name: 'News Feed',
        iconClasses: 'fas fa-newspaper',
        path: ['/main/news-feed']
    },
    {
        name: 'Press Release',
        iconClasses: 'far fa-newspaper',
        path: ['/main/press-release']
    },
    /*{
      name: 'Clients',
      iconClasses: 'fas fa-handshake',
      path: ['/main/company-partners']
    }*/
    /*{
      name: 'Blank',
      iconClasses: 'fas fa-file',
      path: ['/main/blank']
    },
    {
      name: 'Main Menu',
      iconClasses: 'fas fa-folder',
      children: [
        {
          name: 'Sub Menu',
          iconClasses: 'far fa-address-book',
          path: ['/main/sub-menu-1']
        },
        {
          name: 'Blank',
          iconClasses: 'fas fa-file',
          path: ['/main/sub-menu-2']
        }
      ]
    }*/
];

export const NsCollegeMenu = [
    {
        name: 'Gallery',
        iconClasses: 'fas fa-images',
        path: ['/main/gallery']
    },
    {
        name: 'News Feed',
        iconClasses: 'fas fa-newspaper',
        path: ['/main/news-feed']
    },
    {
        name: 'Add Student',
        iconClasses: 'fas fa-user-plus',
        path: ['/main/students']
    },
    {
        name: 'Function report',
        iconClasses: 'fas fa-file',
        path: ['/main/function']
    },
    {
        name: 'Library report',
        iconClasses: 'fas fa-file',
        path: ['/main/library']
    },
    {
        name: 'Balance Sheet',
        iconClasses: 'fas fa-file',
        path: ['/main/balance-sheet']
    },
];

export const AALighting = [
  {
    name: "Gallery",
    iconClasses: "fas fa-images", // 📷 Images
    path: ["/main/gallery"],
  },
  {
    name: "Auditorium",
    iconClasses: "fas fa-photo-video", // 🎞️ Gallery/Auditorium
    path: ["/main/auditorium"],
  },
  {
    name: "Testimonials",
    iconClasses: "fas fa-comments", // 💬 Feedback / Reviews
    path: ["/main/testimonial"],
  },
  {
    name: "Social Media",
    iconClasses: "fas fa-share-alt", // 🔗 Social Sharing
    path: ["/main/social-media"],
  },
]

export const CIFAmenu = [
  {
    name: "Gallery",
    iconClasses: "fas fa-images", // 📷 Images
    path: ["/main/gallery"],
  },
   {
    name: "Auditorium",
    iconClasses: "fas fa-photo-video", // 🎞️ Gallery/Auditorium
    path: ["/main/auditorium"],
  },
  {
    name: "Social Media",
    iconClasses: "fas fa-share-alt", // 🔗 Social Sharing
    path: ["/main/social-media"],
  },
  {
    name: "Events",
    iconClasses: "fas fa-calendar-alt", // 📅 Events
    path: ["/main/events"],
  },
    {
    name: "Banners",
    iconClasses: "fas fa-image", // 📅 Events
    path: ["/main/banner-image"],
  },
  {
    name: "Production",
    iconClasses: "fas fa-comments",
    path: ["/main/production"],
  },
  {
    name: "Volunteers",
    iconClasses: "fas fa-hands-helping", // 🙋 Volunteers
    path: ["/main/volunteer"],
  },
  {
    name: "Artists",
    iconClasses: "fas fa-palette", // 🎨 Artists
    path: ["/main/artist"],
  },
  // {
  //   name: "Sponsors",
  //   iconClasses: "fas fa-handshake", // 🤝 Sponsors
  //   path: ["/main/sponsor"],
  // },
  {
    name: "Donate",
    iconClasses: "fas fa-donate", // 💖 Donate
    path: ["/main/donate"],  
  },
  {
    name: "Feedback",
    iconClasses: "fas fa-comments", // 💬 Feedback
    path: ["/main/feedback"],
  }

];
